// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import Form from '@core/forms/base';
import { TOWER_FIELDS } from '@shared/constants/asset';

export default class TowerForm extends Form {
  setup() {
    return {
      fields: [
        {
          name: TOWER_FIELDS.name,
          type: 'text',
          rules: 'required',
        },
        {
          name: TOWER_FIELDS.serialNumber,
          type: 'text',
          rules: 'required',
        },
        {
          name: TOWER_FIELDS.customerId,
          rules: 'required',
        },
        {
          name: TOWER_FIELDS.imageInfo.name,
          fields: [
            {
              name: TOWER_FIELDS.imageInfo.fields.image,
              type: 'text',
            }
          ]
        },
        {
          name: TOWER_FIELDS.address.name,
          fields: [
            {
              name: TOWER_FIELDS.address.fields.state,
              type: 'text',
              rules: 'required',
            },
            {
              name: TOWER_FIELDS.address.fields.city,
              type: 'text',
              rules: 'required',
            },
            {
              name: TOWER_FIELDS.address.fields.zipCode,
              type: 'text',
              rules: 'required',
            },
            {
              name: TOWER_FIELDS.address.fields.country,
              type: 'text',
              rules: 'required',
            },
            {
              name: TOWER_FIELDS.address.fields.addressLine,
              type: 'text',
              rules: 'required',
            },
          ],
        },
        {
          name: TOWER_FIELDS.coordinates.name,
          fields: [
            {
              name: TOWER_FIELDS.coordinates.fields.lat,
              type: 'text',
              rules: 'required|number',
            },
            {
              name: TOWER_FIELDS.coordinates.fields.lon,
              type: 'text',
              rules: 'required|number',
            },
          ],
        },
        {
          name: TOWER_FIELDS.construction.name,
          fields: [
            {
              name: TOWER_FIELDS.construction.fields.height,
              type: 'text',
              rules: 'required|number|positive',
            },
            {
              name: TOWER_FIELDS.construction.fields.type,
              rules: 'required',
            },
          ],
        },
        {
          name: TOWER_FIELDS.note,
          type: 'text',
        },
        { 
          name: TOWER_FIELDS.isBlocked,
          value: false
        }
      ],
    };
  }
}
